import styled from "styled-components";

import {
  DefaultGroupShellWrapper,
  TableContentWrapper,
} from "@FillInTableContainer/shared/styles/table.style";

export const TableWrapper = styled(TableContentWrapper)`
  background-color: transparent;
  gap: 0;
`;

export const GroupShellWrapper = styled(DefaultGroupShellWrapper)`
  background-color: #f8f9fa;
`;
